<template>
  <div
    class="molecules-cover-tiers bg-semantic-surface-container-lowest py-10 md:py-20 px-4"
  >
    <div class="max-w-wrapper-lg mx-auto">
      <!-- eslint-disable vue/no-v-html -->
      <p
        v-if="title"
        ref="title"
        class="mx-auto text-center text-2xl/[120%] md:text-4xl/[120%] mb-2 md:mb-4 text-semantic-inverse-surface font-semibold"
        v-html="title"
      />

      <p
        v-if="desc"
        class="mx-auto md:text-lg/[150%] text-center text-semantic-inverse-surface"
        v-html="desc"
      />

      <div
        class="grid grid-cols-1 mt-6 md:mt-10 gap-4 md:gap-8"
        :class="{
          'md:grid-cols-6': list.length > 4,
          'md:grid-cols-2': list.length <= 4,
        }"
      >
        <V2MoleculesCardFeatureCard
          v-for="(item, itemKey) in list"
          :key="itemKey"
          :title="item.title"
          :badge-title="item.type"
          :description="item.desc"
          text-align="left"
          :class="getWrapperClass(itemKey)"
          :header-icon="hideHeaderIcon ? null : item.icon"
          :icon-props="item.iconProps"
          header-icon-class="w-10 h-10"
          :inverted="inverted"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'V2OrganismHomeCoverTiers'
})

const props = defineProps({
  title: {
    type: String,
    default: ''
  },

  desc: {
    type: String,
    default: ''
  },

  inverted: {
    type: Boolean,
    default: true
  },

  hideHeaderIcon: {
    type: Boolean,
    default: true
  },

  list: {
    type: Array,
    default: () => []
  },

  reverseFlow: {
    type: Boolean,
    default: false
  }
})

const getWrapperClass = computed(() => itemKey => {
  const classes = ['max-w-full']

  if (!props.reverseFlow) {
    if (itemKey < 3 && props.list.length === 5) {
      classes.push('md:col-span-2')
    }

    if (itemKey >= props.list.length - 2 && props.list.length === 5) {
      classes.push('md:col-span-3')
    }
  }

  if (props.reverseFlow) {
    if (itemKey < 2 && props.list.length === 5) {
      classes.push('md:col-span-3')
    }

    if (itemKey >= props.list.length - 3 && props.list.length === 5) {
      classes.push('md:col-span-2')
    }
  }

  return classes.join(' ')
})
</script>
